function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "_24px_notes",
  "data-name": "24px_notes",
  transform: "translate(-2)"
}, React.createElement("g", {
  id: "Group_4806",
  "data-name": "Group 4806",
  transform: "translate(2)"
}, React.createElement("path", {
  id: "Path_11930",
  "data-name": "Path 11930",
  d: "M13.083,3H11.917V5.917H3.75V3H2.583A.583.583,0,0,0,2,3.583V14.667a.583.583,0,0,0,.583.583h10.5a.583.583,0,0,0,.583-.583V3.583A.583.583,0,0,0,13.083,3Zm-1.75,9.333h-7V11.167h7Zm0-2.917h-7V8.25h7Z",
  transform: "translate(-2 -1.25)",
  fill: "#f90"
}), React.createElement("path", {
  id: "Path_11931",
  "data-name": "Path 11931",
  d: "M11.083,1.167a1.167,1.167,0,1,0-2.333,0H7V3.5h5.833V1.167Z",
  transform: "translate(-4.083)",
  fill: "#f90"
})));

var Svg24PxNotes = function Svg24PxNotes(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 11.667,
    height: 14,
    viewBox: "0 0 11.667 14",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg24PxNotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/24px_notes.25c6c05f.svg";
export { ForwardRef as ReactComponent };